import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import CryptoJS from "crypto-js";

export default function New_Usuario({ history }) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  //const [isMaster, setIsMaster] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [idempresa, setIdempresa] = useState("");

  const isMaster = localStorage.getItem("sgimaster")

  const checkadmin = () => {
    const b_admin = localStorage.getItem("sgiadmin");
    if (b_admin != "true") history.push("/painel");
  };

  async function loadEmpresas() {
    const query = "/treinamentos/empresa";
    const response = await api.get(query);
    const data = await response.data;
    setEmpresas(data);
    setIdempresa(localStorage.getItem("sgiempresaid"));
    setLoading(false);
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const hashPwd = CryptoJS.SHA3(pwd).toString();

    const dataobj = {
      nome: nome,
      email: email,
      pwd: hashPwd,
      telefone: "1",
      isAdmin,
      isMaster: false,
      idempresa,
    };

    await api
      .post("/treinamentos/usuarios/", dataobj)
      .then((res) => {
        if (res.data.error != undefined) {
          alert(res.data.error);
          setLoading(false);
          return;
        } else {
          setLoading(false);
          history.push("/usuarios");
        }
      })
      .catch((error) => {
        alert(error);
        setLoading(false);
        return;
      });
  }

  useEffect(() => {
    setLoading(true);
    checkadmin();
    loadEmpresas();
    setTimeout(() => {
      if (document.getElementById("menu_usuario")) {
        document.getElementById("menu_usuario").className = "active";
      }
    }, 50);
    setLoading(false);
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            {"Novo Usuário"}
            {/* <small>
              &nbsp;( {"Compressor"} )
            </small> */}
          </h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-primary">
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="nome">
                        Nome*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="nome"
                          placeholder="Nome Completo do Usuário"
                          className="form-control"
                          required
                          maxLength={60}
                          value={nome}
                          onChange={(event) => setNome(event.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="preco">
                        E-mail*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="email"
                          placeholder="E-mail do Usuário"
                          className="form-control"
                          required
                          maxLength={100}
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="nome">
                        Senha*
                      </label>
                      <div className="col-sm-4">
                        <input
                          id="nome"
                          type="password"
                          placeholder="Senha do Usuário"
                          className="form-control"
                          required
                          maxLength={20}
                          value={pwd}
                          onChange={(event) => setPwd(event.target.value)}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group">
                      <label
                        className="col-sm-2"
                        htmlFor="preco"
                      >
                        Telefone
                      </label>
                      <div className="col-sm-4">
                      <input
                        id="email"
                        placeholder="Telefone do Usuário"
                        className="form-control"
                        required
                        maxLength={14}
                        value={telefone}
                        onChange={event => setTelefone(event.target.value)}
                        />
                        </div>
                    </div> */}

                    {/*
                        
                          if access_web === true 
                          show dropbox to inform if it is a Checklist creator or Checklist Approver
                          create property to usuario model and include new field named web_resp
                          0 = Creator
                          1 = Approver

                        */}

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="idcompressor">
                        Empresa*
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="idcompressor"
                          value={idempresa}
                          placeholder="Empresa do usuário"
                          className="form-control select2"
                          required
                          disabled={isMaster == "false"}
                          onChange={(event) => setIdempresa(event.target.value)}
                        >
                          <option key="" value="" disabled>
                            -- Selecione --
                          </option>
                          {empresas.map((empresa) => (
                            <option key={empresa._id} value={empresa._id}>
                              {empresa.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="preco">
                        Área de Acesso*
                      </label>
                      <div className="checkbox">
                        <label style={{ paddingLeft: 35 }}>
                          <input
                            id="isAdmin"
                            type="checkbox"
                            checked={isAdmin === true ? "checked" : ""}
                            onChange={(event) => {
                              setIsAdmin(!isAdmin);
                            }}
                          />
                          Administrador
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      className="btn btn-default"
                      style={{ marginRight: 8 }}
                      onClick={() => history.push("/usuarios")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div>

                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80"></img>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
